// ProductType Vuex

import state from './expiredStates.js'
import * as getters from './expiredGetters.js'
import * as mutations from './expiredMutations.js'
import * as actions from './expiredActions.js'

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
